import { defineMessages } from 'react-intl';

export default defineMessages({
  loginPageTitle: {
    id: 'login_page.title',
  },
  loginPageSubTitle: {
    id: 'login_page.subtitle',
  },
  connectionButton: {
    id: 'login_page.connection_button',
  },
  username: {
    id: 'login_page.username',
  },
  password: {
    id: 'login_page.password',
  },
});
